const events = new Map();

export default {
  on(event, callback) {
    const callbacks = events.get(event) || [];
    callbacks.push(callback);
    events.set(event, callbacks);
  },

  off(event, callback) {
    if (!events.has(event)) {
      return;
    }

    if (!callback) {
      events.delete(event);
      return;
    }

    events.set(
      event,
      events.get(event).filter((registeredCallback) => registeredCallback !== callback)
    );
  },

  emit(event, ...args) {
    (events.get(event) || []).forEach((callback) => callback(...args));
  },
};
